import { Phone, MapPin, CalendarDays } from "lucide-react";
import { KEVALTEK_LOGO, NAKODA_LOGO } from "@/data";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink py-16" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <img src={KEVALTEK_LOGO} alt="KevalTek Expo" className="h-14 w-auto" />
            <p className="mt-5 max-w-xs font-sans text-sm text-muted-foreground">
              Mysore&apos;s biggest CCTV &amp; surveillance expo. See it. Experience it. Grow together.
            </p>
          </div>

          <div className="space-y-4 font-mono-tech text-sm text-muted-foreground">
            <div className="flex items-center gap-3">
              <CalendarDays className="h-4 w-4 text-orange" /> 30 &amp; 31 July 2026
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-orange" />
              Arcor Hotels, 1(N), K.R.S. Road Junction, Metagalli, Mysuru
            </div>
            <a href="tel:+919900456780" className="flex items-center gap-3 hover:text-white">
              <Phone className="h-4 w-4 text-orange" /> +91 99004 56780
            </a>
          </div>

          <div className="flex flex-col items-start gap-4">
            <span className="overline text-muted-foreground">Organized by</span>
            <div className="rounded-sm bg-white p-3">
              <img src={NAKODA_LOGO} alt="Nakoda Electronics" className="h-12 w-auto" />
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 font-mono-tech text-xs text-muted-foreground sm:flex-row sm:items-center">
          <span>© 2026 KevalTek Expo · Nakoda Electronics. All rights reserved.</span>
          <a href="/admin" className="uppercase tracking-[0.15em] hover:text-orange" data-testid="footer-admin-link">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
